module.exports = __webpack_public_path__ + "static/media/fmcsa.c98279e9.jpg";